import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
interface usuario {
  idUsuario: number;
  username: string;
  nombreUsuario: string;
  appUsuario: string;
  apmUsuario: string;
  fechainipass: string;
  caducapass: string;
  telefono: number;
  calle: string;
  colonia: string;
  delegacion: string;
  estado: string;
  cp: string;
  idcatuserStatus: number;
  Fails: number;
  idPerfil: string;
  fi_restablecer: number;
  token: string;
  refreshToken: string;
}
const usuarioVacio = {
  idUsuario: null,
  username: "",
  nombreUsuario: "",
  appUsuario: "",
  apmUsuario: "",
  fechainipass: "",
  caducapass: "",
  telefono: null,
  calle: null,
  colonia: "",
  delegacion: "",
  estado: null,
  cp: "",
  idcatuserStatus: "",
  Fails: "",
  idPerfil: "",
  fi_restablecer: 0,
  token: "",
  refreshToken: ""
};

export interface UiState {

  refreshToken: string;
  token: string;
  seleccion: string;
  usuario: any;
  etapaActual: number;
  fc_sub_etapa: string;
  valida: boolean;
  p_seleccion: string;
  fecha_inicio: any;
  fecha_elapsed: any;
  menu: boolean;
  fi_llamada_id: number;
  fi_producto: number;
  SA_Importe: string;
  Promass: string;
  E_mail_Aseg: string;
  Asegurado: string;
  ApellidoP_Aseg: string;
  ApellidoM_Aseg: string;
  RFC: string;
  Fecha_Nac: string;
  Tel_Cas_Aseg: string;
  Tel_Cel_Aseg: string;
  Calle_Aseg: string;
  Num_Ext_Aseg: string;
  Num_Int_Aseg: string;
  Estado_Aseg: string;
  Colonia_Aseg: string;
  Delegacion_Aseg: string;
  Ciudad_Aseg: string;
  Canal: string;
}

const initialState: UiState = {
  token:
    typeof window !== "undefined"
      ? localStorage.getItem("app_token")
        ? localStorage.getItem("app_token")
        : ""
      : "",
  seleccion:
    typeof window !== "undefined"
      ? localStorage.getItem("app_seleccion")
        ? localStorage.getItem("app_seleccion")
        : ""
      : "",
  refreshToken:
    typeof window !== "undefined"
      ? localStorage.getItem("app_refresh_token")
        ? localStorage.getItem("app_refresh_token")
        : ""
      : "",
  usuario: usuarioVacio,
  etapaActual: 0,
  fc_sub_etapa: "prueba",
  valida: true,
  p_seleccion: "",
  fecha_inicio: null,
  fecha_elapsed: null,
  menu: true,
  fi_llamada_id: 0,
  fi_producto: 0,
  SA_Importe: "",
  Promass: "",
  E_mail_Aseg: "",
  Asegurado: "",
  ApellidoP_Aseg: "",
  ApellidoM_Aseg: "",
  RFC: "",
  Fecha_Nac: "",
  Tel_Cas_Aseg: "",
  Tel_Cel_Aseg: "",
  Calle_Aseg: "",
  Num_Ext_Aseg: "",
  Num_Int_Aseg: "",
  Estado_Aseg: "",
  Colonia_Aseg: "",
  Delegacion_Aseg: "",
  Ciudad_Aseg: "",
  Canal: "",
};

export const uiSlice = createSlice({
  initialState,
  name: "ui",
  reducers: {
    iniciarSesion: (state, action: PayloadAction<usuario>) => {
      state.usuario = action.payload;
      state.valida = false;
    },
    agregarToken: (state, action: PayloadAction<any>) => {
      console.log(action.payload);
      localStorage.setItem("app_token", action.payload.token);
      localStorage.setItem("app_refresh_token", action.payload.refreshToken);
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    limpiarSesion: (state) => {
      localStorage.removeItem("app_token");
      localStorage.removeItem("app_refresh_token");
      state.token = "";
      state.refreshToken = "";
      state.usuario = null;
    },
    agregarSeleccion: (state, action: PayloadAction<any>) => {
      console.log(action.payload);
      localStorage.setItem("app_seleccion", action.payload);
      state.seleccion = action.payload;
    },
    cambiarEtapa: (state, action: PayloadAction<any>) => {
      console.log("pruebaX", action.payload);
      state.etapaActual = action.payload.etapaActual;
      state.fc_sub_etapa = action.payload.fc_sub_etapa;
    },
    cambiaValida: (state, action: PayloadAction<number>) => {
      state.valida = true;
    },
    seleccionarPagina: (state, action: PayloadAction<any>) => {
      state.p_seleccion = action.payload;
    },
    setInicioFecha: (state, action: any) => {
      let fecha: any = new Date();
      let fecha_dos: any = new Date(action.payload);

      state.fecha_elapsed = fecha - fecha_dos;
      state.fecha_inicio = action.payload;
    },
    incrementTime: (state) => {
      state.fecha_elapsed += 1000; // Sumar un segundo
    },
    resetTimer: (state) => {
      state.fecha_inicio = null;
      state.fecha_elapsed = null;
    },
    cerrarMenu: (state, action: PayloadAction<number>) => {
      state.menu = !state.menu;
    },
    AgregarProdImporte: (state, action: PayloadAction<any>) => {
      state.fi_producto = action.payload.fi_producto;
      state.SA_Importe = action.payload.SA_Importe;
      state.Promass = action.payload.Promass;
      state.E_mail_Aseg = action.payload.E_mail_Aseg;
      state.Asegurado = action.payload.Asegurado;
      state.ApellidoP_Aseg = action.payload.ApellidoP_Aseg;
      state.ApellidoM_Aseg = action.payload.ApellidoM_Aseg;
      state.RFC = action.payload.RFC;
      state.Fecha_Nac = action.payload.Fecha_Nac;
      state.Tel_Cas_Aseg = action.payload.Tel_Cas_Aseg;
      state.Tel_Cel_Aseg = action.payload.Tel_Cel_Aseg;
      state.Calle_Aseg = action.payload.Calle_Aseg;
      state.Num_Ext_Aseg = action.payload.Num_Ext_Aseg;
      state.Num_Int_Aseg = action.payload.Num_Int_Aseg;
      state.Estado_Aseg = action.payload.Estado_Aseg;
      state.Colonia_Aseg = action.payload.Colonia_Aseg;
      state.Delegacion_Aseg = action.payload.Delegacion_Aseg;
      state.Ciudad_Aseg = action.payload.Ciudad_Aseg;
      state.Canal = action.payload.Canal;
    },
    agregarLlamadaID: (state, action: PayloadAction<any>) => {
      state.fi_llamada_id = action.payload.fi_llamada_id;
    },
  },
});

export const {
  iniciarSesion,
  cambiarEtapa,
  agregarToken,
  cambiaValida,
  agregarSeleccion,
  seleccionarPagina,
  setInicioFecha,
  incrementTime,
  resetTimer,
  cerrarMenu,
  AgregarProdImporte,
  agregarLlamadaID,
  limpiarSesion,
} = uiSlice.actions;

export default uiSlice.reducer;
